import { api } from 'shared/api/common'

function getGuide (url) {
  return api.get(`/api/v3/supplier/guides/${url}/`)
}

export {
  getGuide,
}
